import ScrollMagic from 'scrollmagic';
import gsap from 'gsap/dist/gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import { Slideshow } from './slideshow';

gsap.registerPlugin(ScrollTrigger);
const mm = gsap.matchMedia();

const slides = document.querySelector<HTMLElement>('.js-hero-slider');
if (slides) {
  const slideshow = new Slideshow(slides);

  const prevBtns: any[] = [].slice.call(document.querySelectorAll('.js-hero-slider-prev'));
  const nextBtns: any[] = [].slice.call(document.querySelectorAll('.js-hero-slider-next'));
  const indexBtns: any[] = [].slice.call(document.querySelectorAll('.js-slider-dot'));

  prevBtns.forEach(function(prevBtn: any) {
    prevBtn.addEventListener('click', () => slideshow.prev());
  });
  nextBtns.forEach(function(nextBtn: any) {
    nextBtn.addEventListener('click', () => slideshow.next());
  });
  indexBtns.forEach(function(indexBtn: any) {
    const index = indexBtn.getAttribute('data-idx');
    indexBtn.addEventListener('click', () => slideshow.indexed(index));
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const controller = new ScrollMagic.Controller();
  const scrollItems = document.querySelectorAll('.js-animate');

  scrollItems.forEach((item) => {
    new ScrollMagic.Scene({ triggerElement: item })
      .triggerHook('onEnter')
      .removeClassToggle(false)
      .setClassToggle(item, 'is-show')
      .addTo(controller);
  });

  mm.add('(min-width: 992px)', () => {
    // general image parallax effect
    const parallaxImages = [].slice.call(document.querySelectorAll('.js-parallax-img'));
    parallaxImages.forEach(function(img) {
      gsap.fromTo(img, {
        yPercent: 'random(-25, -10, 1)',
      }, {
        yPercent: 10,
        scrollTrigger: {
          trigger: img,
          scrub: true,
        },
      });
    });
  });
});
